<div class="grid ">
    <div class="col-12 text-center footer">
        <p><small>© 2023 Plymouth Rock Assurance. All Rights Reserved.</small>
        </p>
    </div>
</div>
